// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"yqOV8eH1qXG003j4glRp","absoluteWrapper":"iSe6ljFwjDfz9C8GB6x1","headerWrapper":"AUwJOnY80aWhund3sJaf"};